export var activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development';

if (typeof activeEnv !== 'undefined' && activeEnv && activeEnv === Object(activeEnv) && Object.isExtensible(activeEnv) && !Object.prototype.hasOwnProperty.call(activeEnv, '__filemeta')) {
  Object.defineProperty(activeEnv, '__filemeta', {
    configurable: true,
    value: {
      name: "activeEnv",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/helpers/index.js"
    }
  });
}

export var isUrl = function isUrl(str) {
  try {
    return Boolean(new URL(str));
  } catch (e) {
    return false;
  }
};

if (typeof isUrl !== 'undefined' && isUrl && isUrl === Object(isUrl) && Object.isExtensible(isUrl) && !Object.prototype.hasOwnProperty.call(isUrl, '__filemeta')) {
  Object.defineProperty(isUrl, '__filemeta', {
    configurable: true,
    value: {
      name: "isUrl",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/helpers/index.js"
    }
  });
}

export var removeSlashes = function removeSlashes(str) {
  return str.replace(/^\/|\/$/g, '');
};

if (typeof removeSlashes !== 'undefined' && removeSlashes && removeSlashes === Object(removeSlashes) && Object.isExtensible(removeSlashes) && !Object.prototype.hasOwnProperty.call(removeSlashes, '__filemeta')) {
  Object.defineProperty(removeSlashes, '__filemeta', {
    configurable: true,
    value: {
      name: "removeSlashes",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/helpers/index.js"
    }
  });
}

export var getPublicUrl = function getPublicUrl(base, src) {
  return activeEnv !== 'development' && !isUrl(src) && base && base.length ? "/" + removeSlashes(base) + "/" + removeSlashes(src) : src;
};

if (typeof getPublicUrl !== 'undefined' && getPublicUrl && getPublicUrl === Object(getPublicUrl) && Object.isExtensible(getPublicUrl) && !Object.prototype.hasOwnProperty.call(getPublicUrl, '__filemeta')) {
  Object.defineProperty(getPublicUrl, '__filemeta', {
    configurable: true,
    value: {
      name: "getPublicUrl",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/helpers/index.js"
    }
  });
}